import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c071319"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "i"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-white text-24px font-bold" }, "用户名", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-white font-normal mt-2 text-13px" }, "您还未成为会员", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "i2"
}
const _hoisted_7 = { style: {"margin-top":"-40px","padding":"10px"} }
const _hoisted_8 = { class: "b-m" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "会员权益", -1))
const _hoisted_10 = { class: "flex flex-row items-center mt-32px" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "每满10000工分可兑换为1积分", -1))
const _hoisted_12 = { class: "flex flex-row items-center mt-30px" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "完成每日任务，可获得3倍工分奖励", -1))
const _hoisted_14 = { class: "b-m mt-12px" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "立刻成为会员", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sub-title" }, "达成以下条件即可成为会员", -1))
const _hoisted_17 = { class: "flex-1 ml-13px" }
const _hoisted_18 = { class: "task-title" }
const _hoisted_19 = { class: "task-description" }
const _hoisted_20 = { class: "flex flex-col items-center w-100px" }
const _hoisted_21 = { class: "c-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "b-t",
      style: _normalizeStyle({
        backgroundImage: _ctx.isVip
          ? 'url(' + $setup.vipBackground + ')'
          : 'url(' + $setup.noVipBackground + ')'
      })
    }, [
      (!_ctx.isVip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
        : (_openBlock(), _createElementBlock("p", _hoisted_6, "从不撒谎王浩宇"))
    ], 4),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_van_image, {
            src: $setup.tipsCircle,
            width: "20px",
            height: "20px"
          }, null, 8, ["src"]),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_van_image, {
            src: $setup.tipsCircle,
            width: "20px",
            height: "20px"
          }, null, 8, ["src"]),
          _hoisted_13
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _hoisted_16,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.title,
            class: "flex flex-row items-center mt-16px justify-between"
          }, [
            _createVNode(_component_van_image, {
              src: item.icon,
              width: "39px",
              height: "39px"
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, _toDisplayString(item.title), 1),
              _createElementVNode("p", _hoisted_19, _toDisplayString(item.description), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: "btn",
                style: _normalizeStyle({
                  background:
                    item.current >= item.total
                      ? ' #B9B9B9'
                      : 'linear-gradient(90deg, #ffe9b8 0%, #ffd6af 100%)',
                  color: item.current >= item.total ? '  #FFFFFF' : '#6b2d00'
                })
              }, _toDisplayString(item.current >= item.total ? '已完成' : item.btnTitle), 5),
              _createElementVNode("div", _hoisted_21, " 已完成" + _toDisplayString(item.current) + "/" + _toDisplayString(item.total), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}